import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Ads/grumft-banner-footer-fixed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Ads/grumft-iab-ad.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Header/navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/ModalCookie/modal-cookie.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/Others/back-top.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/ScriptsClient/abfpush-image-optimizer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/ScriptsClient/error-suppressor.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/ScriptsClient/module-script-client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/tvfoco-headless/src/app/Components/ScriptsClient/service-worker-register.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/src/app/globals.css");
